import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const customerBaseOptions = async () => axios.get(Routes.CUSTOMER_BASE_OPTIONS);

export const useCustomerBaseOptions = () =>
  useQuery({
    queryKey: [Keys.CUSTOMERS_BASE_OPTIONS_QRY],
    queryFn: customerBaseOptions,
  });
